module.exports = __webpack_public_path__ + "static/media/background-stainless.f4a87cdd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/background-stainless.jpg
// module id = 1014
// module chunks = 0